import PhoneInput from "react-phone-input-2"
import styles from "../../../styles/Participant-Employment.module.css"
import { checkErrorValidation } from "./formikAux"
import "react-phone-input-2/lib/style.css"

const PhoneField = ({
  label,
  value,
  setValue,
  valueName,
  error,
  required,
  style,
  lblStyle,
  disabled,
}) => {
  return (
    <>
      <div className={styles.field} style={style}>
        <label
          className={`${styles.label} ${required && styles.requiredField}`}
          style={lblStyle}
        >
          {label}
        </label>
        <PhoneInput
          country={"us"}
          value={value}
          className={"p-inputtext-md"}
          onChange={(phone) => {
            valueName
              ? setValue(valueName, { phone }.phone)
              : setValue({ phone }.phone)
          }}
          disabled={disabled}
          inputClass={styles.phone_field}
          inputStyle={
            valueName
              ? checkErrorValidation(error)
                ? { borderColor: "red" }
                : {}
              : {}
          }
        />
        {valueName && checkErrorValidation(error) && error}
      </div>
    </>
  )
}
export default PhoneField
